import React from "react";
import { Chip } from "@mui/material";
import axios from "axios";

function loadScript(src) {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
}

const AcceptedRequest = ({
  user,
  name,
  desg,
  price,
  logo,
  profile,
  slot,
  status,
  payment,
  card_id,
}) => {
  async function displayRazorpay() {
    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }

    const data = await fetch(`${process.env.REACT_APP_SERVER_URL}/razorpay`, {
      method: "POST",
      body: JSON.stringify({
        card_id,
      }),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    }).then((t) => t.json());

    console.log(data);

    const options = {
      key: "rzp_test_n5BctsEFJhYRue",
      currency: data.currency,
      amount: data.amount.toString(),
      order_id: data.id,
      name: "Donation",
      description: "Thank you for nothing. Please give us some money",
      image:
        "https://static.toiimg.com/thumb/msid-67586673,width-800,height-600,resizemode-75,imgsize-3918697,pt-32,y_pad-40/67586673.jpg",
      handler: function (response) {
        alert(response.razorpay_payment_id);
        alert(response.razorpay_order_id);
        alert(response.razorpay_signature);
      },
      prefill: {
        name: "Suryansh Yadav",
        email: "suryansh.y@example.com",
        contact: "9999999999",
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#3399cc",
      },
    };
    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  }
  if (status !== "accepted" || payment === true) {
    return;
  }
  const timeDuration = (slot) => {
    let text = slot;
    const myArray = text.split(" ");
    const arr1 = myArray[0].split(":");
    const arr2 = myArray[3].split(":");
    const h1 = parseInt(arr1[0]);
    const h2 = parseInt(arr2[0]);
    const m1 = parseInt(arr1[1]);
    const m2 = parseInt(arr2[1]);
    return 60 * (h2 - h1) + (m2 - m1);
  };

  return (
    <>
      <div className="relative w-full overflow-hidden bg-white box-shadow-request-card grid grid-cols-4 rounded-lg my-4 p-2">
        <div className="absolute bottom-1 right-2 text-right">
          <p className="text-xs text-gray-400">Sent 45 Min ago</p>
          <p className="text-xs text-gray-400">Accepted 15 Min ago</p>
        </div>
        <div className="border-r border-gray-400 my-auto col-span-1">
          <img
            src={require("../../../images/photo.png")}
            className="h-32 rounded-full border-2 border-black p-1 block mx-auto"
            alt="Profile"
          />
          <button className="view-profile-card-btn w-4/5 mt-2 mx-auto">
            View Profile
          </button>
        </div>
        <div className="px-3 col-span-3">
          <div className="flex py-1 justify-between w-full">
            <div className="w-12 h-12 logo-shadow mx-1 rounded-lg">
              <img src={require("../../../images/amazon.png")} alt="google" />
            </div>
            <div className="text-center">
              <h4 className="text-2xl font-medium leading-4">{name}</h4>
              <p>{desg}</p>
            </div>
            <div className="flex gap-2">
              <div className="flex justify-center border rounded-md p-2 w-10 h-10 text-blue-500 text-2xl hover:text-blue-600 cursor-pointer">
                <i className="fa-solid fa-bookmark"></i>
              </div>
              <div className="flex justify-center border rounded-md p-2 w-10 h-10 text-green-500 text-2xl hover:text-green-600 cursor-pointer">
                <i className="fa-solid fa-share"></i>
              </div>
            </div>
          </div>
          <div
            className="flex justify-between text-center my-1 gap-x-1 mx-2"
            style={{ alignItems: "flex-start" }}
          >
            <div>
              <p className="text-base text-gray-400">Profile</p>
              <Chip
                label={profile}
                color="info"
                sx={{ fontWeight: "medium" }}
              />
            </div>
            <div>
              <p className="text-base text-gray-400">Price</p>
              <p className="text-lg">INR 299</p>
            </div>
            <div>
              <p className="text-base text-gray-400">Session Duration</p>
              <p className="text-lg">30 Min</p>
            </div>
            <div>
              <p className="text-base text-gray-400">Interview Slot</p>
              <p className="text-lg">[{slot}]</p>
              <p className="text-lg">20 June, 2022</p>
            </div>
          </div>
          <div className="relative flex justify-center">
            <form>
              <button
                type="button"
                className="cust-btn request-accepted-btn font-medium"
                // onClick={
                //   () => {
                //         const obj = {
                //           payment:true
                //         };
                //         axios
                //           .patch(`http://localhost:8585/api/edit/${id}`, obj)
                //           .then((response) => {
                //             console.log(response.status);
                //             console.log(response.data);
                //           });
                //           window.alert("Are you sure?")
                //       }}
                onClick={displayRazorpay}
              >
                Pay & Confirm
              </button>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AcceptedRequest;
